import { render } from "./UserSettingPageGeneralTasking.vue?vue&type=template&id=061eb0dd&scoped=true"
import script from "./UserSettingPageGeneralTasking.vue?vue&type=script&lang=js"
export * from "./UserSettingPageGeneralTasking.vue?vue&type=script&lang=js"

import "./UserSettingPageGeneralTasking.vue?vue&type=style&index=0&id=061eb0dd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-061eb0dd"]])

export default __exports__